import { ContentLoggedOutComponent } from './components/content-loggedout.component';
import { RouterModule } from '@angular/router';
import { BrandsResolver } from './resolvers/brands.resolver';
import { CountriesResolver } from './resolvers/countries.resolver';
import { ContentComponent } from './components/content.component';
import { OrderComponent } from './order/order.component';
import { QuoteComponent } from './order/quote.component';
import { OrderPartComponent } from './order/wizard/orderpart.component';
import { OrderAddressComponent, OrderAddressGuard } from './order/wizard/orderaddress.component';
import { OrderBillingComponent, OrderBillingGuard } from './order/wizard/orderbilling.component';
import { OrderShippingComponent, OrderShippingGuard } from './order/wizard/ordershipping.component';
import { OrderSummaryComponent, OrderSummaryGuard } from './order/wizard/ordersummary.component';
import { OrderCompletedComponent, OrderCompletedGuard, QuoteCompletedGuard } from './order/wizard/ordercompleted.component';
import { QrComponent } from './QR/qrcomponent.component';
var appRoutes = [
    { path: '', component: ContentLoggedOutComponent },
    {
        path: '',
        component: ContentComponent,
        children: [
            { path: 'history', loadChildren: './history/history.module#HistoryModule' },
            { path: 'brands', loadChildren: './brands/brands.module#BrandsModule' },
            { path: 'qr', component: QrComponent },
            {
                path: 'order',
                component: OrderComponent,
                children: [
                    { path: '', redirectTo: '/order/part', pathMatch: 'full' },
                    { path: 'part', component: OrderPartComponent, resolve: { brands: BrandsResolver, countries: CountriesResolver } },
                    { path: 'address', component: OrderAddressComponent, resolve: { countries: CountriesResolver }, canActivate: [OrderAddressGuard] },
                    { path: 'billing', component: OrderBillingComponent, canActivate: [OrderBillingGuard] },
                    { path: 'shipping', component: OrderShippingComponent, canActivate: [OrderShippingGuard] },
                    { path: 'summary', component: OrderSummaryComponent, canActivate: [OrderSummaryGuard] },
                    { path: 'completed', component: OrderCompletedComponent, canActivate: [OrderCompletedGuard] }
                ]
            },
            {
                path: 'quote',
                component: QuoteComponent,
                children: [
                    { path: '', redirectTo: '/quote/part', pathMatch: 'full' },
                    { path: 'part', component: OrderPartComponent, resolve: { brands: BrandsResolver, countries: CountriesResolver } },
                    { path: 'address', component: OrderAddressComponent, resolve: { countries: CountriesResolver }, canActivate: [OrderAddressGuard] },
                    { path: 'summary', component: OrderSummaryComponent, canActivate: [OrderSummaryGuard] },
                    { path: 'completed', component: OrderCompletedComponent, canActivate: [QuoteCompletedGuard] }
                ]
            },
        ]
    },
    //{ path: 'vieworder', loadChildren: './vieworder/vieworder.module#ViewOrderModule' },
    //{ path: 'help',      loadChildren: './help/help.module#HelpModule' },
    //{ path: 'account',   loadChildren: './account/account.module#AccountModule' },
    { path: "**", redirectTo: '/', pathMatch: 'full' }
];
export var routing = RouterModule.forRoot(appRoutes);
//# sourceMappingURL=app.routing.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/app.routing.js
// module id = 1157
// module chunks = 0